import { FeatureItem } from '@/app/[locale]/pricing/components/feature-item/feature-item'

type TooltipFeatureProps = {
    name: string
    description: string
}

export function TooltipFeature({ name, description }: TooltipFeatureProps) {
    return <FeatureItem name={name} description={description} toggleVisible={true} variant="sm" />
}
